module.exports = __webpack_public_path__ + "img/mp3.22c267ce.png";